var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('ul', {
    staticClass: "Polaris-Tabs",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.tabNames), function(name) {
    return _c('li', {
      staticClass: "Polaris-Tabs__TabContainer",
      attrs: {
        "role": "presentation"
      }
    }, [_c('button', {
      class: {
        'Polaris-Tabs__Tab': 1, 'Polaris-Tabs__Tab--selected': _vm.activeTab == name
      },
      attrs: {
        "role": "tab",
        "tabindex": "-1"
      },
      on: {
        "click": function($event) {
          _vm.activeTab = name
        }
      }
    }, [_c('span', {
      staticClass: "Polaris-Tabs__Title"
    }, [_vm._v(_vm._s(name))])])])
  }))]), _vm._v(" "), _vm._l((_vm.tabNames), function(name) {
    return (name == _vm.activeTab) ? _c('div', {
      staticStyle: {
        "padding": "1.6rem"
      }
    }, [_vm._t(name)], 2) : _vm._e()
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52c5e046", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52c5e046","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisTabs.vue
// module id = 346
// module chunks = 0